import {useState} from 'react';
import DataTable from '../../components/DataTable/DataTable';
import { useProfilePrograms } from '../../hooks/useProfilePrograms';
import DataMap from '../../components/DataMap/DataMap';
import { Icon } from 'leaflet';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import ProgramModal from '../../components/MarkerModals/ProgramModal/ProgramModal';

const customIcon = new Icon({
    iconUrl : require('../../components/DataMap/assets/marker.png'),
    iconSize: [38,38]
})

const dataColumns = [
    {label: "Πρόγραμμα", key: "scheduleName"},
    {label: "Δεδομένα", key: "schedule"},
    {label: "Ενεργοποιημένο", key: "isActive"},
    {label: "Ημ/νία Δημιουργίας", key: "dateCreated"},
    {label: "Ενέργειες", key: "actions"},
];


const TimeProgramming = () => {
    const [selectedDevices, setSelectedDevices] = useState([]);
    const {devices,programs, sunriseProgram, disablePrograms,  page, rowsPerPage, totalCount, handleChangePage, handleChangeRowsPerPage} = useProfilePrograms(selectedDevices);
    const [modalOpen, setModalOpen] = useState(false);

    const handleMarkersSelected = (results) => {
        if (results) {
          setSelectedDevices(results);
        }
    };

    return (
        <>
            <div className="mb-4">
                <DataMap  markers ={devices} deviceType = "timeProgramming" customIcon = {customIcon} onMarkersSelected={handleMarkersSelected} modalFetcher={null}/>
            </div>
            
            <Card className="mb-4" sx={{ minHeight: '400px', minWidth: '400px', display: 'flex'}}>
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <i className={"fa fa-map-pin text-info"} style={{ fontSize: '80px' }} />
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                        <Typography style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Σύνολο Συσκευών: {selectedDevices.length}</Typography>
                        {selectedDevices.length !== 0 && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

                                <List dense style={{ maxHeight: 200, overflowY: 'auto' }}>
                                {selectedDevices.map((marker, index) => (
                                    <ListItem key={index}>
                                    {marker.deviceUid}
                                    </ListItem>
                                ))}
                                </List>
                            </div>
                        )}


                    </div>
                </CardContent>
            </Card>
            
            <div className="mb-4">
                <Button
                    variant="contained"
                    startIcon={<ElectricBoltIcon />}
                    onClick={() => setModalOpen(true)}
                >
                    ΝΕΟ ΠΡΟΓΡΑΜΜΑ
                </Button>

                <DataTable
                    columns={dataColumns}
                    data={programs}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalCount={totalCount}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div> 

            <Card className="mb-4">
                <CardHeader title={"Πρόγραμμα Ανατολής Δύσης του Ηλίου"}/>

                <CardContent>
                        <i className={"fa fa-moon text-info"} style={{ fontSize: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
                        <p>
                            Επιλέξτε 100% φωτισμό μισή ώρα πριν τη δύση του ηλίου και 0% φωτισμό μισή ώρα μετά την ανατολή του ηλίου στις επιλεγμένες συσκευές:
                            *Προσωρινά μη διαθέσιμο για τις συσκευές Fonda. Επιλέξτε κάποιο προγραμμα για τις συσκευές Fonda ή δημιουργήστε νέο π.χ. 100% στις 18:00 και 0% στις 6:00.
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                            <Button
                                variant="contained"
                                startIcon={<ElectricBoltIcon />}
                                onClick={sunriseProgram}
                            >
                                Ενεργοποίηση
                            </Button>
                        </div>

                </CardContent>
            </Card>

            <Card className="mb-4">
                <CardHeader title={"Απενεργοποίηση όλων των Προγραμμάτων"}/>

                <CardContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

                        <Button
                            variant="contained"
                            startIcon={<ElectricBoltIcon />}
                            sx={{ mt: 2, alignSelf: 'flex-start' }}
                            onClick={disablePrograms}
                        >
                            Απενεργοποίηση όλων των προγραμμάτων
                        </Button>

                </CardContent>
            </Card>
            
            <ProgramModal open ={modalOpen}  onClose={() => setModalOpen(false)} />
        </>
    );
};


export default TimeProgramming;

